var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Iterator',{attrs:{"items":_vm.docs,"title":"Tutorials","displayItem":_vm.displayComponent}})
}
var staticRenderFns = []

export { render, staticRenderFns }